<form #form="ngForm">

    <app-group-box title="SFTP connection details" [required]="true" [isValid]="isValid" [disabled]="disabled()" [supportsEdit]="endpointOwner() === 'Customer'" (editClicked)="editTransport(value())">
        <div class="details-content">
            @if (endpointOwner() === 'Customer') {
                <p class="endpoint-owner-note">{{endpointOwnerNote()}}</p>
                <div class="property-grid">
                    <p class="field-name">Type:</p>
                    <p class="field-value">{{sftpTypeText()}}</p>
                    <p class="field-name">Host name:</p>
                    <p class="field-value">{{hostname()}}</p>
                    <p class="field-name">Port:</p>
                    <p class="field-value">{{port()}}</p>
                    <p class="field-name">Inbound folder:</p>
                    <p class="field-value">{{inboundFolder()}}</p>
                    <p class="field-name">Outbound folder:</p>
                    <p class="field-value">{{outboundFolder()}}</p>
                    <p class="field-name">Credentials:</p>
                    <p class="field-value">{{credentialsStatusText()}}</p>
                </div>
            } @else if (endpointOwner() === 'Partner') {
                <p class="endpoint-owner-note">{{endpointOwnerNote()}}</p>
                @for (field of value()?.TransportFields ?? []; track $index)
                {
                    <ul>
                        <li>{{field.Description}}</li>
                    </ul>
                }
            }                                        
        </div>
    </app-group-box>

</form>